import React, { useEffect, useState } from 'react'
import './styles.scss'
import { lang } from 'utils/helpers'
import { role } from 'api'
import { InputControls } from 'components/common'
import Nixi1Spinner from 'components/Nixi1Spinner'
import SaveToastNotification from 'utils/toasts/SaveToastNotification'

const RolesManagement = () => {
  const [permissionList, setPermissionList] = useState([])
  const [permissions, setPermissions] = useState([])
  const [loading, setLoading] = useState(false)

  useEffect(() => {
    getListRoles()
  }, [])

  const getListRoles = async () => {
    setLoading(true)
    try {
      const { data } = await role.getPermissionListRoles()
      setPermissionList(data)
      setPermissions(Object.keys(data[0].permissions))
    } catch (error) {
      SaveToastNotification.error({ text: lang('dashboard_error-get-permission-list') })
    } finally {
      setLoading(false)
    }
  }

  const handleOnChange = ({ permission, value, rol }) => {
    updateLocalPermission({ permission, value, rol })

    role.updatePermissionList({
      resource: permission,
      resourceValue: value,
      role: rol
    })
      .then(() => SaveToastNotification.ok())
      .catch(() => {
        SaveToastNotification.error()
        updateLocalPermission({ permission, value: !value, rol })
      })
  }

  const updateLocalPermission = ({ permission, value, rol }) => {
    setPermissionList(prevState => prevState.map(state => state.role === rol
      ? ({
        ...state,
        permissions: {
          ...state.permissions,
          [permission]: value
        }
      })
      : state
    ))
  }

  return (
    <div className='roles-container'>
      <h1 className='roles-container__text'>{lang('dashboard_roles')}</h1>
      <span className='roles-container__legend'>{lang('dashboard_manages-user-role-permissions-platform')}</span>
      <div className='roles-container-table'>

        {loading ? <Nixi1Spinner width={'35px'} height={'35px'} />
          : permissionList.length ? <table>
            <thead
              className='roles-container-table__thead'
            >
              <tr>
                <th className='roles-container-table__thead--th roles-container-table__thead--th-rol'>{lang('dashboard_rol')}</th>
                {permissionList.map((item, index) => (
                  <th
                    className='roles-container-table__thead--th'
                    key={index}
                  >
                    {lang(`roles_${item.role}`)}
                  </th>
                ))}
              </tr>
            </thead>
            <tbody className='roles-container-table__body'>
              {permissions.map((permission, index) => (
                <tr key={index}>
                  <td className='roles-container-table__body--td roles-container-table__body--td-rol'>{lang(`dashboard_${permission}`)}</td>
                  {permissionList.map((item, index) => (
                    <td key={index} className='roles-container-table__body--td'>
                      <InputControls
                        injectType='external'
                        className='checkOptions'
                        type='checkbox'
                        value={item.permissions[permission]}
                        onChange={value => handleOnChange({ permission, value, rol: item.role })}
                        color='newPrimary'
                      />
                    </td>
                  ))}
                </tr>

              ))}
            </tbody>
          </table> : null
        }
      </div>
    </div>
  )
}

export default RolesManagement